/** Local-first persistence. localStorage is the source of truth so progress
 *  survives reload and offline use; the server sync (sync.ts) is best-effort. */
import type { StoredGame } from './state';

const PREFIX = 'sudoku:game:';

export function saveLocal(game: StoredGame): void {
  try {
    localStorage.setItem(PREFIX + game.key, JSON.stringify(game));
  } catch {
    // Storage full / disabled — non-fatal; in-memory state still works.
  }
}

export function loadLocal(key: string): StoredGame | null {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    return raw ? (JSON.parse(raw) as StoredGame) : null;
  } catch {
    return null;
  }
}

export function removeLocal(key: string): void {
  try {
    localStorage.removeItem(PREFIX + key);
  } catch {
    /* ignore */
  }
}

export function listLocal(): StoredGame[] {
  const games: StoredGame[] = [];
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k?.startsWith(PREFIX)) {
        const raw = localStorage.getItem(k);
        if (raw) games.push(JSON.parse(raw) as StoredGame);
      }
    }
  } catch {
    /* ignore */
  }
  return games.sort((a, b) => b.updatedAt - a.updatedAt);
}
